import { registerFr } from '../i18n/index.js';

registerFr({
  'Context': 'Contexte',
  '— every organisation —': '— toutes les organisations —',
}, 'AppShell');
